import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../../../environments/environment';

@Injectable()
export class ProductCategoryCreateService {
  private urlPrefix: string = environment.appUrl;
  constructor(
    private http: HttpClient
  ) {}

  create(post): Observable<any> {
    const url = this.urlPrefix + 'product-cats';
    return this.http
      .post(url, {
        name: post.name.value
      }, { observe: 'response' })
      .map(
        res => {
          if (res.status === 201) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/create/create.service.ts